import { inlineScript } from "@decocms/blocks/sdk/useScript";

export interface Props {
    event: Item[]
}

export interface Item {
    label: string
    value: string
}

declare global {
    interface Window {
        dataLayer: unknown[]
    }
}

const HANDLER = `(event) => {
    const push = () => {
        const layer = event.reduce((acc, currentValue) => {
            acc[currentValue.label] = currentValue.value;
            return acc;
        }, {});
        if (typeof window !== "undefined" && window.dataLayer) {
            window.dataLayer.push(layer);
        }
    };
    if (document.readyState === "complete") {
        push();
    } else {
        window.addEventListener("load", push, { once: true });
    }
}`

export default function SendCustomEventOnView({ event }: Props) {
    return (
        <script
            defer
            {...inlineScript(`(${HANDLER})(${JSON.stringify(event)})`)}
        />
    )
}
